var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAudio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.75 15C2.75 13.7574 3.75736 12.75 5 12.75H7.25V15C7.25 16.2426 6.24264 17.25 5 17.25C3.75736 17.25 2.75 16.2426 2.75 15Z",
    stroke: "#2E2B63",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.75 14C10.75 12.7574 11.7574 11.75 13 11.75H15.25V14C15.25 15.2426 14.2426 16.25 13 16.25C11.7574 16.25 10.75 15.2426 10.75 14Z",
    stroke: "#2E2B63",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.25 12.5V5.28078C7.25 4.82191 7.5623 4.42193 8.00746 4.31063L14.0075 2.81063C14.6386 2.65285 15.25 3.13021 15.25 3.78078V11.5",
    stroke: "#2E2B63",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 8L15.5 6",
    stroke: "#2E2B63",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudio);
export default __webpack_public_path__ + "static/media/audio.0faca6339e01d09f89bd8aaf244e181b.svg";
export { ForwardRef as ReactComponent };